<template>
  <v-container>
    <v-overlay
      :value="!!$route.params.sayfaID && sayfaGuncelleData === null"
      :opacity="0.2"
      color="white"
    >
      <v-card color="primary" dark width="250">
        <v-card-text class="pt-1">
          <div class="py-2 text-center">{{$t('SAYFALAR.DETAIL.LOADING_PAGE_DETAIL')}}</div>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>
    <v-row>
      <v-col cols="12" class="pb-0">
        <panel-title
          v-if="!sayfaGuncelleData"
          icon="mdi-note-plus-outline"
          :title="$t('SAYFALAR.DETAIL.ADD_PAGE_TITLE')"
          :desc="$t('SAYFALAR.DETAIL.ADD_PAGE_SUB_TITLE')"
        >
          <template v-slot:append-inner>
            <v-btn small class="text-capitalize" @click="$router.back()" text color="error">
              <v-icon size="15" class="mr-1">mdi-close</v-icon>{{$t('SAYFALAR.DETAIL.CANCEL_ADDING_BTN')}}
            </v-btn>
          </template>
        </panel-title>
        <panel-title
          v-else
          icon="mdi-file-edit-outline"
          :title="$t('SAYFALAR.DETAIL.EDIT_PAGE_TITLE')"
          :desc="$t('SAYFALAR.DETAIL.EDIT_PAGE_SUB_TITLE')"
        >
          <template v-slot:append-inner>
            <v-btn small class="text-capitalize" @click="$router.back()" text color="error">
              <v-icon size="15" class="mr-1">mdi-close</v-icon>{{$t('SAYFALAR.DETAIL.CANCEL_UPDATING_BTN')}}
            </v-btn>
          </template>
        </panel-title>
      </v-col>
      <v-col cols="12" lg="9">
        <v-card class="px-2 py-2 mb-3" rounded="md">
          <div>
            <p class="text-subtitle-1 d-flex align-center mb-0 text-overline">
              <v-icon size="5" color="blue" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>{{$t('SAYFALAR.DETAIL.TYPING.PAGE_TITLE')}}
            </p>
          </div>
          <div class="py-2">
            <v-text-field
              :label="$t('SAYFALAR.DETAIL.TYPING.PAGE_TITLE_LABEL')"
              v-model="sayfaData.baslik"
              hide-details
              outlined
              dense
            ></v-text-field>
          </div>
          <v-divider class="my-2"></v-divider>
          <div>
            <p class="text-subtitle-1 d-flex align-center mb-2 text-overline">
              <v-icon size="5" color="blue" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>{{$t('SAYFALAR.DETAIL.TYPING.PAGE_CONTENT_TITLE')}}
            </p>
          </div>
          <div>
            <cheetah-editor
              v-model="sayfaData.icerik"
              :set-content="setContent"
              @firstContent="setContent = $event"
              editor-base-color="blue"
              editor-selecting-color="blue darken-4"
              editor-passive-color="blue lighten-5"
              editor-border-color="#90CAF9"
            />
          </div>
          <v-divider class="my-3"></v-divider>
          <div>
            <p class="text-subtitle-1 d-flex align-center mb-2 text-overline">
              <v-icon size="5" color="blue" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>{{$t('SAYFALAR.DETAIL.TYPING.SEO_DESCRIPTION_TITLE')}}
              <v-spacer></v-spacer>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-on="on"
                    v-bind="attrs"
                    class="text-capitalize"
                    x-small
                    :color="!seoIcerikEvent ? 'grey darken-3 white--text' :'grey lighten-2'"
                    @click="seoIcerikEvent = !seoIcerikEvent"
                  >
                    <v-icon size="15" class="mr-1">mdi-link-variant</v-icon>
                    <span v-show="seoIcerikEvent">{{$t('SAYFALAR.DETAIL.TYPING.BIND_TO_CONTENT_BTN')}}</span>
                    <span v-show="!seoIcerikEvent">{{$t('SAYFALAR.DETAIL.TYPING.DETACH_FROM_CONTENT_BTN')}}</span>
                  </v-btn>
                </template>
                <span v-show="seoIcerikEvent">{{$t('SAYFALAR.DETAIL.TYPING.BIND_TO_CONTENT_BTN')}}</span>
                <span v-show="!seoIcerikEvent">{{$t('SAYFALAR.DETAIL.TYPING.DETACH_FROM_CONTENT_BTN')}}</span>
              </v-tooltip>
            </p>
          </div>
          <div>
            <v-textarea
              v-model="sayfaData.seoIcerik"
              outlined
              height="80"
              :counter="seoIcerikLimit"
              :rules="rules.seoIcerik"
              @focus="seoIcerikEvent = true"
              :label="$t('SAYFALAR.DETAIL.TYPING.SEO_DESCRIPTION_LABEL')"
            ></v-textarea>
          </div>
          <v-divider class="my-3 mt-0"></v-divider>
          <div>
            <p class="text-subtitle-1 d-flex align-center mb-2 text-overline">
              <v-icon size="5" color="blue" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>{{$t('SAYFALAR.DETAIL.TYPING.PERMANENT_LINK')}}
            </p>
          </div>
          <div class="sayfa-field">
            <v-text-field
              outlined
              dense
              :prefix="webSiteUrl"
              :readonly="readonly"
              hide-details
              v-model="sayfaData.link"
              ref="seoLink"
            >
              <template v-slot:append-outer class="my-0">
                <v-tooltip bottom v-if="!editLink">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-on="on" v-bind="attrs" color="blue" fab small dark @click="linkEdit">
                      <v-icon>mdi-pen</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('SAYFALAR.DETAIL.TYPING.EDIT_LINK_BTN')}}</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      color="success"
                      fab
                      small
                      dark
                      @click="linkEdit"
                      :loading="editLinkLoading"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('SAYFALAR.DETAIL.TYPING.SAVE_LINK_BTN')}}</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" lg="3">
        <v-card class="px-2 py-2 pb-4 mb-4">
          <div>
            <p class="text-subtitle-1 mb-1 text-overline">
              <v-icon size="5" color="blue" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>{{$t('SAYFALAR.DETAIL.ACTIONS.TITLE')}}
            </p>
          </div>
          <div>
            <v-menu offset-y :nudge-bottom="2">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="!sayfaGuncelleData"
                  v-on="on"
                  v-bind="attrs"
                  width="100%"
                  dark
                  color="blue"
                >
                  <v-icon left>mdi-note-plus-outline</v-icon>{{$t('SAYFALAR.DETAIL.ACTIONS.ADD_PAGE_BTN')}}
                </v-btn>
                <v-btn v-else v-on="on" v-bind="attrs" width="100%" dark color="success">
                  <v-icon left>mdi-note-plus-outline</v-icon>{{$t('SAYFALAR.DETAIL.ACTIONS.UPDATE_PAGE_BTN')}}
                </v-btn>
              </template>
              <v-list
                :class="!sayfaGuncelleData ? 'blue lighten-5' : 'success lighten-5'"
                class="py-0"
              >
                <v-list-item
                  link
                  @click="!sayfaGuncelleData ? sayfaEkle(1) : sayfaGuncelle(1)"
                  color
                >
                  <div>
                    <v-icon color left>mdi-check-all</v-icon>
                    <span class="grey--text text--darken-3">{{$t('SAYFALAR.DETAIL.ACTIONS.PUBLISH_NOW_BTN')}}</span>
                  </div>
                </v-list-item>
                <v-list-item
                  link
                  @click="!sayfaGuncelleData ? sayfaEkle(0) : sayfaGuncelle(0)"
                  color
                >
                  <div>
                    <v-icon color left>mdi-text-box-check</v-icon>
                    <span class="grey--text text--darken-3">{{$t('SAYFALAR.DETAIL.ACTIONS.MARK_AS_DRAFT_BTN')}}</span>
                  </div>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-card>
        <v-card class="px-2 py-2 pb-4 mb-4">
          <div>
            <p class="text-subtitle-1 mb-1 text-overline">
              <v-icon size="5" color="blue" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>{{$t('SAYFALAR.DETAIL.PARENT_SELECTING.TITLE')}}
            </p>
          </div>
          <div>
            <v-select
              :label="$t('SAYFALAR.DETAIL.PARENT_SELECTING.NO_PARENT')"
              v-model="sayfaData.parent"
              outlined
              hide-details
              dense
              clearable
              :no-data-text="$t('SAYFALAR.DETAIL.PARENT_SELECTING.NO_PAGE_ADDITIONAL')"
              :items="guncelSayfaListesi"
              item-text="name"
              item-value="code"
            ></v-select>
          </div>
        </v-card>
        <v-card class="px-2 py-2 mb-3" rounded="lg">
          <div>
            <p class="text-subtitle-1 d-flex align-center mb-2 text-overline">
              <v-icon size="5" color="blue" class="ml-1 mr-2">mdi-checkbox-blank-circle</v-icon>{{$t('SAYFALAR.DETAIL.THUMBNAIL_TEXT')}}
            </p>
          </div>
          <div>
            <thumbnail-viewer :no-text="$t('SAYFALAR.DETAIL.THUMBNAIL_NOT_SELECT')" v-model="sayfaData.thumbnail" />
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CheetahEditor from "../../../components/CheetahEditor.vue";
import PanelTitle from "../../../components/PanelTitle.vue";
import ThumbnailViewer from "../../../components/ThumbnailViewer.vue";
import SayfalarService from "@/services/SayfalarService.js";
import RouterService from "@/services/RouterService.js";
import OptionService from "@/services/OptionService.js";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  components: { CheetahEditor, PanelTitle, ThumbnailViewer },
  name: "SayfaDetay",
  inject: ["webSiteUrl"],
  data: vm => ({
    sayfaData: {
      sayfaCode: "",
      baslik: "",
      icerik: "",
      seoIcerik: "",
      link: "",
      thumbnail: "",
      parent: 0
    },
    sayfaGuncelleData: null,
    editorIcerik: "",
    setContent: "",
    editLink: false,
    editLinkLoading: false,
    readonly: true,
    baslikTimeout: "",
    rules: {
      seoIcerik: [
        value =>
          (value || "").length <= vm.seoIcerikLimit ||
            vm.$t('SAYFALAR.DETAIL.TYPING.SEO_CONTENT_WARN')
      ]
    },
    seoIcerikLimit: 160,
    seoIcerikEvent: false,
    sayfaListesi: [],
    guncelSayfaListesi: [],
    sayfaDataMap: {
      sayfaCode: "code",
      baslik: "name",
      // icerik: "desc",
      // seoIcerik: "seoIcerik",
      link: "link",
      thumbnail: "thumbnail",
      parent: "parent"
    },
    baslikSeoLinkTimeout: 650
  }),
  computed: {
    ...mapGetters({
      sayfaListesiHiyerarsik: "Sayfalar/SayfaList/sayfalarGrouped"
    })
  },
  methods: {
    linkEdit() {
      this.$refs.seoLink.$el.querySelector("input").focus();
      if (this.editLink) {
        this.readonly = true;
        this.checkLink(this.sayfaData.link).then(() => (this.editLink = false));
      } else {
        this.readonly = false;
        this.editLink = true;
      }
    },
    checkLink(link) {
      this.editLinkLoading = true;

      /**
       * Veri güncelleme verisi ise link'i ona göre getir
       */
      let seoUrlMethod = "seoUrl",
        update = null;
      if (this.sayfaGuncelleData) {
        seoUrlMethod = "seoUpdateUrl";
        update = link;
        link = this.sayfaGuncelleData.link;
      }

      return new Promise(resolve => {
        RouterService[seoUrlMethod]({ link, update }).then(res => {
          this.editLinkLoading = false;
          if (res.status === 200) {
            this.sayfaData.link = res.data;
          }
          resolve(res);
        });
      });
    },
    sayfaEkle(publish) {
      const {
        baslik,
        icerik,
        link,
        thumbnail,
        parent,
        seoIcerik
      } = this.sayfaData;
      SayfalarService.sayfaEkle({
        baslik,
        icerik,
        link,
        thumbnail,
        parent,
        seoIcerik,
        publish
      }).then(res => {
        if (res.status === 200) {
          this.$snotify.success(this.$t('SAYFALAR.NOTIFY.PAGE_ADD_SUCCESS'), this.$t('PANEL.NOTIFY.SUCCESS'));

          let realPath = this.routerPath(1);
          this.$router.push(realPath);
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    sayfaGuncelle(publish) {
      const {
        sayfaCode,
        baslik,
        icerik,
        link,
        thumbnail,
        parent,
        seoIcerik
      } = this.sayfaData;
      SayfalarService.sayfaGuncelle({
        sayfaCode,
        baslik,
        icerik,
        link,
        thumbnail,
        parent,
        seoIcerik,
        publish
      }).then(res => {
        if (res.status === 200) {
          this.$snotify.success(this.$t('SAYFALAR.NOTIFY.PAGE_UPDATE_SUCCESS'), this.$t('PANEL.NOTIFY.SUCCESS'));

          let realPath = this.routerPath(2);
          this.$router.push(realPath);
        } else {
          this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        }
      });
    },
    depthLine(length) {
      let lines = "";
      for (let i = 0; i < length; i++) {
        lines += "—";
      }
      return lines;
    },
    routerPath(num) {
      let path = this.$route.path.split("/");
      for (let i = 0; i < num; i++) {
        path.pop();
      }
      return path.join("/");
    },
    removeP(html) {
      var removeRegexP = /<p>(.*)<br><\/p>/g
      return html.replace(removeRegexP, "<br>");
    },
    editorImgSrcParse(data) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(data, "text/html");
      var images = doc.body.querySelectorAll("img");

      if (images) {
        images.forEach(img => {
          img.src = img.src.replace(/(.*)\$apiImagesUrl/, this.$apiImagesUrl);
        });
      }

      return doc.body.innerHTML;
    },
  },
  created() {
    /**
     * Sayfaların listesini getir
     */
    this.$store
      .dispatch("Sayfalar/SayfaList/sayfaListesi")
      .then(res => {
        if (res.status === 200) {
          let sayfaListesiHrk = this.sayfaListesiHiyerarsik(res.data),
            sayfaListesi = [];

          for (let group of sayfaListesiHrk) {
            for (let page of group) {
              page.name = this.depthLine(page.depth) + " " + page.name;
              sayfaListesi.push(page);
            }
          }
          return (this.sayfaListesi = sayfaListesi);
        }
      })
      .then(() => {
        /**
         * Sayfanın düzenleme olup olmadığını kontrol et
         */
        if (this.$route.params.sayfaID) {
          const sayfaCode = Number(this.$route.params.sayfaID);
          return SayfalarService.sayfaGetir({ sayfaCode })
            .then(res => {
              if (res.status === 200) {
                this.sayfaGuncelleData = res.data;
                for (let key in this.sayfaDataMap) {
                  if (Object.hasOwnProperty.call(this.sayfaData, key)) {
                    this.sayfaData[key] = this.sayfaGuncelleData[
                      this.sayfaDataMap[key]
                    ];
                  }
                }

                this.sayfaData.icerik = this.editorImgSrcParse(this.sayfaGuncelleData.desc);
                // this.editorIcerik = this.editorImgSrcParse(this.sayfaGuncelleData.desc);
                this.setContent = this.editorImgSrcParse(this.sayfaGuncelleData.desc);
              } else {
                this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
                this.$router.back();
              }
            })
            .then(() => {
              if (this.sayfaGuncelleData) {
                /**
                 * Güncelleme verisindeki sayfanın alt sayfalarını seçilemeyecek
                 * biçimde iptal et
                 */
                let hierarchy = this.sayfaGuncelleData.hierarchy,
                  code = this.sayfaGuncelleData.code;

                let sayfaGuncelleParent = _.filter(
                    this.sayfaListesi,
                    s => s.hierarchy === hierarchy
                  ),
                  page = _.find(sayfaGuncelleParent, s => {
                    return s.code === code;
                  });

                let sayfaListesi = this.sayfaListesi;
                _.remove(sayfaListesi, s => {
                  return (
                    (s.depth > page.depth && s.hierarchy === hierarchy) ||
                    s.code === code
                  );
                });

                this.$set(this, "sayfaListesi", sayfaListesi);
              }
            });
        }
      })
      .then(() => {
        this.guncelSayfaListesi = this.sayfaListesi;
      });
  },
  watch: {
    // 'sayfaData.icerik': {
    //   handler(htmlContent) {
    //     this.setContent = htmlContent;
    //   }
    // },
    // editorIcerik(data) {
    //   var parser = new DOMParser();
    //   var doc = parser.parseFromString(data, "text/html");
    //   let images = doc.body.querySelectorAll("img");
    //
    //   if (images) {
    //     Object.keys(images).forEach(i => {
    //       images[i].src = String(images[i].src).replace(
    //         `${this.$apiImagesUrl}`,
    //         "$apiImagesUrl"
    //       );
    //     });
    //   }
    //
    //   if (!this.seoIcerikEvent) {
    //     let newLines = parser.parseFromString(
    //         doc.body.innerHTML.replaceAll("><", "> <"),
    //         "text/html"
    //       ),
    //       seoIcerik = newLines.body.innerText;
    //     if (seoIcerik.length <= this.seoIcerikLimit) {
    //       this.sayfaData.seoIcerik = seoIcerik.trim();
    //     }
    //   }
    //   this.sayfaData.icerik = doc.body.innerHTML;
    // },

    /**
     * Başlık değiştiği zaman seo link üret
     */
    "sayfaData.baslik"(value) {
      if (this.baslikTimeout) {
        clearTimeout(this.baslikTimeout);
      }

      this.baslikTimeout = setTimeout(() => {
        this.checkLink(value);
      }, this.baslikSeoLinkTimeout);
    },
    "sayfaData.parent"(value) {
      if (value === undefined) {
        this.sayfaData.parent = 0;
      }
    }
  }
};
</script>

<style>
.sayfa-field .v-input__append-outer {
  display: flex;
  align-items: center;
  margin-top: 0 !important;
  height: 100%;
}
</style>